var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    viewBox: "0 0 24.784 12.805",
    width: 10,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fffffe",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.436 0v8.958H2.347v-4.5H0V12.8h2.347v-2.1h20.089v2.1h2.348V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.076 8.094h18.633v-2.66H3.076zM21.7 1.486c-5.007-.3-6.692 3.222-6.692 3.222H21.7z"
  }))));
}

export default SvgIcnBed;